import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import GovernancePage from '@/pages/GovernancePage';
import ArchetypeScoreboardPage from '@/pages/ArchetypeScoreboardPage';

export default function GovernanceModule() {
  const tabs = [
    { id: 'governance', label: 'Governance', content: <GovernancePage /> },
    { id: 'scoreboard', label: 'Archetype Scoreboard', content: <ArchetypeScoreboardPage /> },
  ];

  return (
    <ModuleShell title="AI Governance" subtitle="Measure, audit, explain & continuously test every agent" tabs={tabs} />
  );
}
